import { MemoizedSelector, createSelector } from "@ngrx/store";
import { MediaRecordState, MediaFeatureState } from "../states";
import { selectMediaFeatureState } from "./media-feature.selectors";



export const selectRecordMediaState: MemoizedSelector<object, MediaRecordState> = createSelector(selectMediaFeatureState, (state: MediaFeatureState) => state.mediaRecord);


const getRecorded = (state: MediaRecordState): boolean => state.record

export const selectRecording: MemoizedSelector<object, boolean> = createSelector(selectRecordMediaState, getRecorded);